/* eslint-disable import/prefer-default-export */
import { errorForConfig, LandingPagesAPIError } from '../errors';

export const statusForState = ({ config, cuisine = {} }) => {
  const error = errorForConfig(config);
  const cuisineError = cuisine.error || {};

  if (error) {
    return {
      status: 500,
      error,
    };
  }

  if (cuisineError.status === 200) {
    // graphql server error
    return {
      status: 404,
      error: new LandingPagesAPIError(`Landing Pages API Error: ${JSON.stringify(cuisineError)}`),
    };
  }

  if (cuisineError.status !== undefined) {
    // graphql request error
    return {
      status: 500,
      error: new LandingPagesAPIError(
        `Landing Pages API Error: Cuisine (${cuisineError.status}) ${cuisineError.message}`,
      ),
    };
  }

  if (!cuisine.cuisine) {
    return { status: 404 };
  }

  return { status: 200 };
};

export const isCuisineRestaurantsOn = (config) =>
  config.features.cuisine_landing_pages_restaurants_section || false;

export const getCuisineLandingPagePath = (request) => {
  const { cuisine, city: citySlug } = request.currentQuery;
  return ['/cuisines', cuisine, citySlug].filter(Boolean).join('/');
};
